import * as React from 'react';
import { CompaniesSelectWithTheme } from 'common/components/companies-select-with-theme';
import { PageHeader } from 'common/components/page-header';
import { AppUrls } from 'routes/index';
import {
  CompanyInfoWrapper,
  CompanyInfoWrapperTabIndexes,
} from 'unit-people/components/company-info-wrapper';
import { Styled } from './company-management.styled';

export const CompanyManagementPage: React.FC<{}> = () => {
  return (
    <Styled.Container>
      <Styled.Header>
        <PageHeader
          redirectUrl={AppUrls.products.path}
        >
          <CompaniesSelectWithTheme />
        </PageHeader>
      </Styled.Header>
      <Styled.Main>
        <CompanyInfoWrapper defaultIndex={CompanyInfoWrapperTabIndexes.Users} />
      </Styled.Main>
    </Styled.Container>
  );
};

